<div class="career-plans-history" *ngIf="completedCareerPlans">
  <div class="career-plans-history__header">
    <div class="icon-col"></div>
    <div class="name-col">{{ careerPlanLabel | translate }}</div>
    <div class="date-col">{{ 'careerPlans.finish.date' | translate }}</div>
  </div>

  <div class="career-plans-history__body">
    <ng-container *ngFor="let careerPlan of completedCareerPlans?.finishedCareerPlans">
      <a routerLinkActive="active" [routerLink]="careerPlan.careerPlanId">
        <div class="career-plans-history__body__row">
          <div class="career-plans-history__body__row__icon icon-col">
            <span class="odilo-icon">format_education</span>
          </div>
          <div class="career-plans-history__body__row__name name-row">{{ careerPlan?.name }}</div>
          <div class="career-plans-history__body__row__date date-col">{{ careerPlan?.finishDate | date }}</div>
        </div>
      </a>
      <router-outlet></router-outlet>
    </ng-container>
  </div>
</div>
